import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Switch, Spin } from 'antd';

type FormValues = {
    // workspace_id: string;
    // property_id: string;
    // user_email: string;
    // metrics: string;
    // dimensions: string;
    // start_date: string;
    // end_date: string;
    // orderBy: string;
    // limit: number;
    // desc: boolean;
    data: string;
};

const Form: React.FC = () => {
    const [data, setData] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const defaultValues = {
        // workspace_id: "Nouria",
        // property_id: "449989382",
        // user_email: "vivek@gapsmiths.com",
        // metrics: "",
        // dimensions: "",
        // start_date: "2025-03-01",
        // end_date: "2025-03-31",
        // orderBy: "",
        // limit: 5,
        // desc: true,
        data: ""
    }
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        watch
    } = useForm<FormValues>({
        defaultValues
    });

    const onSubmit = async (data: FormValues) => {
        setLoading(true)
        // let update = {
        //     metrics: {
        //         ...data,
        //         dimensions: data.dimensions ? data.dimensions.split(",").map((item) => item.trim()) : [],
        //         metrics: data.metrics.split(",").map((item) => item.trim()),
        //         property_id: data.property_id.split(",").map((item) => item.trim()),
        //     }
        // }
        // console.log("Form Data:", data, update);
        await fetch(`${window.location.origin}/api/v1/run-report-testing`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: data?.data,
        })
            .then((response) => response.json())
            .then((data) => {
                setLoading(false)
                setData(data)
            })
            .catch((error) => {
                console.error("Error:", error);
                setLoading(false)
            })

    };

    return (

        <div className="grid grid-cols-2 border mt-3">
            <form onSubmit={handleSubmit(onSubmit)} style={{ display: "flex", flexDirection: "column", gap: "1rem", padding: 10, borderRight: "1px solid grey" }}>
                <div>
                <label>
                    Data Object
                </label>
                    <textarea  {...register("data", { required: "Data is required" })} style={{border:"1px solid",width:"100%",minHeight:"200px"}}/>
                    {errors.data && <p className="text-red-500 text-sm">{errors.data.message}</p>}
                </div>
                {/* <label>
                    Workspace
                    <input
                        className="border border-solid border-gray-500 rounded-md p-2"
                        type="text"
                        {...register("workspace_id", { required: "workspace_id is required" })}
                        placeholder="e.g. Default"

                    />
                    {errors.workspace_id && <p className="text-red-500 text-sm">{errors.workspace_id.message}</p>}
                </label>

                <label>
                    Property ID (comma separated if multiple)
                    <input
                        type="text"
                        className="border border-solid border-gray-500 rounded-md p-2"
                        {...register("property_id", { required: "Property ID is required" })}
                        placeholder="e.g. 449989382,456889 "

                    />
                    {errors.property_id && <p className="text-red-500 text-sm">{errors.property_id.message}</p>}
                </label>

                <label>
                    Email ID
                    <input
                        type="email"
                        className="border border-solid border-gray-500 rounded-md p-2"
                        {...register("user_email")}
                    />
                    {errors.user_email && <p className="text-red-500 text-sm">{errors.user_email.message}</p>}
                </label>

                <label>
                    Metrics (comma separated if multiple)
                    <input
                        type="text"
                        className="border border-solid border-gray-500 rounded-md p-2"
                        placeholder="e.g. activeUsers,inActiveUsers"
                        {...register("metrics", { required: "Metrics required" })} />
                    {errors.metrics && <p className="text-red-500 text-sm">{errors.metrics.message}</p>}
                </label>

                <label>
                    Dimensions (comma separated if multiple)
                    <input
                        type="text"
                        placeholder="e.g. city,country"
                        className="border border-solid border-gray-500 rounded-md p-2" {...register("dimensions")} />
                    {errors.dimensions && <p className="text-red-500 text-sm">{errors.dimensions.message}</p>}
                </label>

                <div className="grid grid-cols-2 gap-5">
                    <label>
                        Start Date
                        <input type="date" className="border border-solid border-gray-500 rounded-md p-2" {...register("start_date", { required: "Start Date required" })} />
                        {errors.start_date && <p className="text-red-500 text-sm">{errors.start_date.message}</p>}
                    </label>

                    <label>
                        End Date
                        <input type="date" className="border border-solid border-gray-500 rounded-md p-2" {...register("end_date", { required: "End Date required" })} />
                        {errors.end_date && <p className="text-red-500 text-sm">{errors.end_date.message}</p>}
                    </label>
                </div>

                <div className="grid grid-cols-2 gap-5">
                    <label>
                        Order By
                        <input type="text" className="border border-solid border-gray-500 rounded-md p-2" {...register("orderBy")} />
                    </label>

                    <label>
                        Limit
                        <input
                            type="number"
                            className="border border-solid border-gray-500 rounded-md p-2"
                            {...register("limit", {
                                required: "Limit is required",
                                valueAsNumber: true,
                                min: { value: 1, message: "Minimum limit is 1" },
                            })}
                        />
                        {errors.limit && <p className="text-red-500 text-sm">{errors.limit.message}</p>}
                    </label>
                </div>

                <label>
                    Desc
                    <Switch
                        checked={watch("desc")}
                        onChange={(checked) => setValue("desc", checked)}
                    />
                </label> */}

                <button type="submit" className="bg-[#4C8067] h-11 text-white font-semibold" disabled={loading}>{loading ? "Loading" : "Submit"}{loading && <Spin style={{ color: "#FFFFFF" }} />}</button>
            </form>
            <div className="p-3">
                <p>Results:</p>
                {
                    loading ? (
                        <div className="flex justify-center items-center">
                            <Spin size="large" />
                        </div>
                    ) : (
                        <pre className="text-sm text-wrap">{JSON.stringify(data, null, 2)}</pre>
                    )
                }
            </div>
        </div>
    );
};

export default Form;
